import React, { useState } from 'react';
import './ChartsContainer.css';
import MyResponsiveBar from './utils/barchart';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ChartWrapper from './utils/ChartWrapper';
import MyTable from './utils/Table';

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EconomicReportTab from './EconomicReport/economicReportTab';
import EnviromentTab from './EnvironmentalReport/enviromentReportTab';

import { useSelector, useDispatch } from 'react-redux';

const getName = (str = '', take1 = false) => {
  if (take1) {
    let word = str.split('_')[0];

    return word.charAt(0).toUpperCase() + word.slice(1);
  } else {
    return str
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 5,
    maxWidth: '55vw',
    padding: '0px 0px',
    fontSize: '15px',
  },
  totaltext: {
    fontFamily: 'sans-serif',
    fontSize: '11px',
    fill: 'rgb(51, 51, 51)',
  },
  // paper: {
  //   padding: theme.spacing(2),
  //   margin: 2,
  //   textAlign: 'center',
  //   color: theme.palette.text.secondary,
  // },
  // formControl: {
  //   margin: theme.spacing(1),
  //   marginBottom: theme.spacing(6),
  //   minWidth: 200,
  // },
  // selectEmpty: {
  //   marginTop: theme.spacing(2),
  // },
  // tableContainer: {
  //   height: 400,
  //   width: "100%",
  // }
}));

function ChartsContainer() {
  const solution = useSelector((state) => state.model.renderedSolution);
  const [workingOnItText, setWorkingOnItText] = useState('');

  const classes = useStyles();

  const projectCost = useSelector(
    (state) =>
      state.model.renderedSolution?.reports?.economic_report?.project_cost
  );
  const table1softcosts = useSelector(
    (state) =>
      state.model.renderedSolution?.reports?.economic_report?.table_1_soft_costs
  );
  const table2preconstruction = useSelector(
    (state) =>
      state.model.renderedSolution?.reports?.economic_report
        ?.table_2_pre_construction
  );
  const table3construction = useSelector(
    (state) =>
      state.model.renderedSolution?.reports?.economic_report
        ?.table_3_construction
  );
  const embodiedcarbonbreakdown = useSelector(
    (state) =>
      state.model.renderedSolution?.reports?.environmental_report
        ?.lca_dictionary?.embodied_carbon_breakdown
  );
  const graphbuiltarea = useSelector(
    (state) =>
      state.model.renderedSolution?.reports?.units_report?.graph_built_area
  );

  const units = useSelector(
    (state) =>
      state.model.renderedSolution?.reports?.units_report?.reported_units
  );
  const currency = useSelector(
    (state) => state.model.renderedSolution?.reports?.economic_report?.currency
  );

  const project_cost = () => {
    let pc = [];
    for (const [key, value] of Object.entries(projectCost)) {
      if (key !== 'total') {
        pc.push({
          id: getName(key),
          label: key,
          value: value.cost,
          ratio: value.ratio,
        });
      }
    }
    return pc;
  };

  const table_1_soft_costs = function settable1soft_costs() {
    if (!solution || !solution.reports) {
      return;
    }
    let t1sc = [];
    for (const [key, value] of Object.entries(table1softcosts)) {
      t1sc.push({
        id: getName(key),
        label: key,
        value: value?.cost,
        ratio: value?.ratio,
      });
    }
    t1sc = t1sc.sort((a, b) => {
      if (a.id === 'Other' || a.id === 'Others') {
        return 1;
      }
      if (b.id === 'Other' || b.id === 'Others') {
        return -1;
      }

      return a.value > b.value ? -1 : 1;
    });
    return t1sc;
  };

  const table_2_pre_construction = function settable2pre_construction() {
    let t2pc = [];
    for (const [key, value] of Object.entries(table2preconstruction)) {
      t2pc.push({
        id: getName(key),
        label: key,
        value: value.cost,
        ratio: value.ratio,
      });
    }
    t2pc = t2pc.sort((a, b) => {
      if (a.id === 'Other' || a.id === 'Others') {
        return 1;
      }
      if (b.id === 'Other' || b.id === 'Others') {
        return -1;
      }

      return a.value > b.value ? -1 : 1;
    });
    return t2pc;
  };

  const table_3_construction = function settable3construction() {
    let t3c = [];
    // eslint-disable-next-line
    for (const [key, value] of Object.entries(table3construction)) {
      t3c.push({
        id: value.name,
        label: value.name,
        value: value.cost,
        ratio: value.ratio,
      });
    }
    return t3c;
  };

  // Embodied Carbon Breakdown
  const embodied_carbon_breakdown = function setEmbodiedCarbonBreakdown() {
    let ecb = [];
    for (const [key, value] of Object.entries(embodiedcarbonbreakdown)) {
      ecb.push({ id: getName(key), label: getName(key), value: value });
    }
    return ecb;
  };
  const embodied_carbon_breakdown_total =
    function setEmbodiedCarbonBreakdown() {
      let ecb = 0;
      for (const [key, value] of Object.entries(embodiedcarbonbreakdown)) {
        ecb = ecb + value;
      }
      return ecb;
    };

  // Graph Built Area
  const graph_built_area = function setGraphBuiltArea() {
    if (!solution || !solution.reports) {
      return;
    }
    let gba = [];
    // eslint-disable-next-line
    for (const [key, value] of Object.entries(graphbuiltarea)) {
      gba.push({
        id: getName(value.name),
        label: getName(value.name),
        value: value.area_by_unit,
      });
    }
    return gba.sort((r, p) => (r.id > p.id ? -1 : 1));
  };

  // Table 2
  const table_2 = function settable2() {
    let t2 = [];
    const x = Object.entries(solution?.reports?.units_report?.table_2);
    // eslint-disable-next-line
    for (const [key, value] of x) {
      t2.push([
        value.name,
        value.number_of_units,
        value.ratio_by_num_of_units,
        value.ratio_by_nla,
        value.ratio_by_total_built_area,
      ]);
    }
    return t2.sort((r, p) => (r[0] > p[0] ? 1 : -1));
  };

  // table_1_flats_overall_income_dict
  const table_1_flats_overall_income_dict =
    function settable_1_flatsoverallincomedict() {
      let t1 = [];
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(
        solution.reports.economic_report.income.flats_overall_income_dict ||
        solution.reports.economic_report.income
          .table_1_flats_overall_income_dict
      )) {
        t1.push([value.name, value.income]);
      }
      return t1;
    };

  const netZeroEnergy = () => {
    if (!solution || !solution.reports) {
      return [
        {
          title: 'Energy Consumption',
          total_KWH_year: 0,
          normalised_kWh_year_m2: 0,
        },
        {
          title: 'Energy Production',
          total_KWH_year: 0,
          normalised_kWh_year_m2: 0,
        },
      ];
    }

    let nzenergy = [
      {
        title: 'Energy Consumption',
        total_KWH_year:
          solution.reports.environmental_report.net_zero_building.energy
            .energy_consumption.total_MWh_year || 0,
        normalised_kWh_year_m2:
          solution.reports.environmental_report.net_zero_building.energy
            .energy_consumption.normalised_kWh_year_m2 || 0,
      },
      {
        title: 'Energy Production',
        total_KWH_year:
          solution.reports.environmental_report.net_zero_building.energy
            .energy_production.total_MWh_year || 0,
        normalised_kWh_year_m2:
          solution.reports.environmental_report.net_zero_building.energy
            .energy_production.normalised_kWh_year_m2 || 0,
      },
    ];
    return nzenergy;
  };

  const netZeroCarpon = () => {
    let nzcarpon = [
      {
        title: 'Savings',
        total_tons_co2_year:
          solution?.reports?.environmental_report.net_zero_building.carbon
            .carbon_savings.total_tons_co2_year || 0,
        normalised_kgco2_m2_year:
          solution?.reports?.environmental_report.net_zero_building.carbon
            .carbon_savings.normalised_kgco2_m2_year || 0,
      },
      {
        title: 'Emissions',
        total_tons_co2_year:
          solution?.reports?.environmental_report.net_zero_building.carbon
            .overall_emissions.total_tons_co2_year,
        normalised_kgco2_m2_year:
          solution?.reports?.environmental_report.net_zero_building.carbon
            .overall_emissions.normalised_kgco2_m2_year,
      },
    ];
    return nzcarpon;
  };

  const energy_consumption_breakwon = () => {
    let ecb = [];
    ecb.push([
      'kWh/year',
      solution?.reports.environmental_report.energy_consumtion.consumption_breakdown?.heating_consumption?.total_kWh_year?.toLocaleString() ||
      '0',
      solution?.reports.environmental_report.energy_consumtion.consumption_breakdown?.cooling_consumption?.total_kWh_year?.toLocaleString() ||
      '0',
      solution?.reports.environmental_report.energy_consumtion.consumption_breakdown?.lighting_consumption?.total_kWh_year?.toLocaleString() ||
      '0',
      (
        (solution?.reports.environmental_report.energy_consumtion
          .consumption_breakdown?.heating_consumption?.total_kWh_year || 0) +
        (solution?.reports.environmental_report.energy_consumtion
          .consumption_breakdown?.cooling_consumption?.total_kWh_year || 0) +
        (solution?.reports.environmental_report.energy_consumtion
          .consumption_breakdown?.lighting_consumption?.total_kWh_year || 0)
      ).toLocaleString(),
    ]);
    ecb.push([
      'kWh/year/' + units + '²',
      solution?.reports.environmental_report.energy_consumtion.consumption_breakdown?.heating_consumption?.normalised_kWh_year_m2?.toLocaleString() ||
      '0',
      solution?.reports.environmental_report.energy_consumtion.consumption_breakdown?.cooling_consumption?.normalised_kWh_year_m2?.toLocaleString() ||
      '0',
      solution?.reports.environmental_report.energy_consumtion.consumption_breakdown?.lighting_consumption?.normalised_kWh_year_m2?.toLocaleString() ||
      '0',
      (
        (solution?.reports.environmental_report.energy_consumtion
          .consumption_breakdown?.heating_consumption?.normalised_kWh_year_m2 ||
          0) +
        (solution?.reports.environmental_report.energy_consumtion
          .consumption_breakdown?.cooling_consumption?.normalised_kWh_year_m2 ||
          0) +
        (solution?.reports.environmental_report.energy_consumtion
          .consumption_breakdown?.lighting_consumption
          ?.normalised_kWh_year_m2 || 0)
      ).toLocaleString(),
    ]);

    return ecb;
  };

  const normalised_emissions_CO2_m2_year =
    function setnormalisedemissionsCO2_m2_year() {
      let ne = [];

      for (const [key, value] of Object.entries(
        solution.reports.environmental_report.lca_dictionary
          .operational_emissions_breakdown.normalised_emissions_CO2_m2_year
      )) {
        ne.push({ id: getName(key, true), value: value });
      }
      return ne;
    };
  const normalised_emissions_CO2_m2_year_total =
    function setnormalisedemissionsCO2_m2_year() {
      let ne = 0;

      for (const [key, value] of Object.entries(
        solution.reports.environmental_report.lca_dictionary
          .operational_emissions_breakdown.normalised_emissions_CO2_m2_year
      )) {
        ne = ne + value;
      }
      return ne;
    };

  const operationalCarbonBreakdown = () => {
    return [
      {
        id: 'Carbon Breakdown',
        embodied:
          solution.reports.environmental_report.lca_dictionary.breakdown
            .embodied_carbon_tonco2_life,
        operational:
          solution.reports.environmental_report.lca_dictionary.breakdown
            .operational_carbon_tonco2_life,
      },
    ];
  };

  const [buttonReportDisabled, setButtonReportDisabled] = useState(false);
  const [buttonModelDisabled, setButtonModelDisabled] = useState(false);

  return (
    <>
      <div className={classes.root}>
        {/* -------------------------------------------------Accordion Area------------------------------------------------- */}
        {graph_built_area() && graph_built_area()?.length > 0 && (
          //  --------------------------------unit report--------------------------------
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.heading}>
                <b>Units Report</b>
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4} lg={5} >
                  <ChartWrapper name={`Built Area (${units}²)`}>
                    <MyResponsiveBar
                      data={graph_built_area()}
                      keys={['value']}
                      indexby={'id'}
                      xtitle={' '}
                      xaxixEnabled={false}
                      isHorizontal={true}
                      colors={{ scheme: 'reds' }}
                      margin={{ top: 0, right: 5, bottom: 0, left: 80 }}
                    />
                  </ChartWrapper>
                </Grid>

                <Grid item xs={12} sm={8} lg={7}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          Efficiency{' '}
                          {solution.reports.units_report.table_1.efficiency?.toLocaleString()}{' '}
                          %
                        </Grid>
                        <Grid item xs={12}>
                          NLA{' '}
                          {solution.reports.units_report.table_1?.nla?.toLocaleString() ||
                            '0'}{' '}
                          {units}²
                        </Grid>
                        <Grid item xs={12}>
                          Total Built Area{' '}
                          {solution.reports.units_report.table_1.total_built_area.toLocaleString()}{' '}
                          {units}²
                        </Grid>
                      </Grid>
                    </Grid>
                    {table_2() && table_2().length > 0 && (
                      <Grid item xs={12}>
                        <MyTable
                          rows={table_2()}
                          columns={[
                            '#',
                            'Number of units',
                            '% of total units',
                            '% of NLA',
                            '% of built area',
                          ]}
                          includeTotals={true}
                        />
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        )}

        {/* --------------------------------Economic Report-------------------------------- */}
        {table_1_soft_costs() && table_1_soft_costs()?.length > 0 && (
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography className={classes.heading}>
                <b>Economic Report</b>
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  {project_cost() && project_cost().length > 0 && (
                    <EconomicReportTab
                      project_cost={project_cost()}
                      table_1_soft_costs={table_1_soft_costs()}
                      table_2_pre_construction={table_2_pre_construction()}
                      table_3_construction={table_3_construction()}
                      solution={solution}
                      table_1_flats_overall_income_dict={table_1_flats_overall_income_dict()}
                    />
                  )}{' '}
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        )}

        {/* --------------------------Environmental Report-------------------------- */}
        {netZeroEnergy() && netZeroEnergy().length > 0 && (
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel3a-content"
              id="panel3a-header"
            >
              <Typography className={classes.heading}>
                <b>Environmental Report</b>
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <EnviromentTab
                netZeroCarpon={netZeroCarpon()}
                netZeroEnergy={netZeroEnergy()}
                solution={solution}
                energy_consumption_breakwon={energy_consumption_breakwon()}
                embodied_carbon_breakdown={embodied_carbon_breakdown()}
                normalised_emissions_CO2_m2_year={normalised_emissions_CO2_m2_year()}
                operationalCarbonBreakdown={operationalCarbonBreakdown()}
                normalised_emissions_CO2_m2_year_total={normalised_emissions_CO2_m2_year_total().toLocaleString()}
                embodied_carbon_breakdown_total={embodied_carbon_breakdown_total().toLocaleString()}
              />
            </AccordionDetails>
          </Accordion>
        )}
        {/* -------------------------------------------------Accordion Area------------------------------------------------- */}

        <div style={{ margin: '5px' }}>
          <button
            type="button"
            style={{ padding: '5px', margin: '5px' }}
            className="btn btn-primary btn-lg"
            disabled={buttonReportDisabled}
            onClick={(e) => {
              setButtonReportDisabled(true);
              setWorkingOnItText('This feature will be available soon!');
              setTimeout((e) => {
                setWorkingOnItText('');
                setButtonReportDisabled(false);
              }, 2000);
            }}
          >
            Export Report
          </button>
          <button
            type="button"
            style={{ padding: '5px', margin: '5px' }}
            className="btn btn-primary btn-lg"
            disabled={buttonModelDisabled}
            onClick={(e) => {
              setButtonModelDisabled(true);
              setWorkingOnItText('This feature will be available soon!');
              setTimeout((e) => {
                setWorkingOnItText('');
                setButtonModelDisabled(false);
              }, 2000);
            }}
          >
            Export Model
          </button>
        </div>
        <div style={{ margin: '10px' }}>
          <p style={{ color: 'red' }}>{workingOnItText}</p>
        </div>
      </div>
    </>
  );
}

export default ChartsContainer;
